import { render, staticRenderFns } from "./ManifestLaporanUmpd.vue?vue&type=template&id=01b2804e&scoped=true&"
import script from "./ManifestLaporanUmpd.vue?vue&type=script&lang=js&"
export * from "./ManifestLaporanUmpd.vue?vue&type=script&lang=js&"
import style0 from "./ManifestLaporanUmpd.vue?vue&type=style&index=0&id=01b2804e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b2804e",
  null
  
)

export default component.exports